"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayCounter = exports.CycleCount = exports.CycleDuration = exports.TankLevelPercentage = exports.SystemEfficiency = exports.DispenseVolumeUsFluidOunces = exports.WaterVolumeUsGallons = exports.FlowRateUsGallonsPerMinute = exports.FlowRateMilliliterPerMinute = exports.WaterTemperatureFahrenheit = exports.CO2SensorAdc = exports.CO2RegulatorGaugePressure = exports.WaterUsagePercentage = exports.RefrigerationCycleTime = exports.Switch = exports.Uptime = exports.WaterConductance = exports.SignalStrength = exports.FloodSensorConnected = exports.FloodSensorTriggered = exports.DispenseVolume = exports.DispenseCount = exports.EnergyUsage = exports.FirewallEffectiveness = exports.ComponentOperationPermitted = exports.ComponentEnabled = exports.WaterPressureDecibar = exports.WaterPressure = exports.FlowRateDeciliterPerMinute = exports.FlowRate = exports.TotalTankTimeouts = exports.TotalHotTankCycles = exports.TotalCompressorCycles = exports.TotalInteractions = exports.TdsReduction = exports.WaterTDS = exports.DripTrayFull = exports.LeakDetected = exports.DoorOpen = exports.WaterDispensed = exports.WaterTemperatureDecicelsius = exports.WaterTemperature = exports.UserPresence = exports.meetsExpectation = exports.Sensor = exports.ExpectAny = exports.ExpectFalse = exports.ExpectTrue = exports.ExpectedSensorValue = exports.NAMESPACE = void 0;
exports.Telemetry = exports.NumberTelemetry = exports.BooleanTelemetry = exports.telemetries = exports.numberTelemetries = exports.booleanTelemetries = exports.EventTime = exports.ReportedSignalStrength = exports.CellularBitErrorRate = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../schema");
const Unit = __importStar(require("../../../unit"));
exports.NAMESPACE = 'Culligan.Device.Capability.Telemetry';
const Value = (0, schema_1.Singleton)('value');
const booleanMeetsExpectation = effect_1.Match.typeTags()({
    Any: () => () => true,
    Boolean: ({ value }) => (other) => value === other,
});
const numberMeetsExpectation = effect_1.Match.typeTags()({
    Any: () => () => true,
    Minimum: ({ min }) => (other) => other >= min,
    Maximum: ({ max }) => (other) => other <= max,
    Range: ({ min, max }) => (other) => other >= min && other <= max,
});
exports.ExpectedSensorValue = effect_1.Data.taggedEnum();
exports.ExpectTrue = exports.ExpectedSensorValue.Boolean({ value: true });
exports.ExpectFalse = exports.ExpectedSensorValue.Boolean({ value: false });
exports.ExpectAny = exports.ExpectedSensorValue.Any();
exports.Sensor = effect_1.Data.taggedEnum();
/**
 * Returns `true` if the given Telemetry meets the expectations of the given sensor.
 *
 * If the type doesn't match the expected type, this function returns false.
 * Otherwise, we use the sensor's `expectedValue` property to validate the
 * value and return the result.
 */
const meetsExpectation = (sensor, telemetry) => exports.Sensor.$match(sensor, {
    Boolean: ({ expectedValue, type }) => telemetry instanceof type && booleanMeetsExpectation(expectedValue)(telemetry.value),
    Number: ({ expectedValue, type }) => telemetry instanceof type && numberMeetsExpectation(expectedValue)(telemetry.value),
});
exports.meetsExpectation = meetsExpectation;
const UserPresenceValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.UserPresenceValue`,
    description: 'A boolean indicating whether a user is present',
});
class UserPresence extends effect_1.Schema.Class(`${exports.NAMESPACE}.UserPresence`)({ value: UserPresenceValue }, { identifier: `${exports.NAMESPACE}.UserPresence` }) {
    static FromScalar = UserPresenceValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'User Presence';
    static description = 'When a user is in front of the product';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['User'];
    static unit = null;
}
exports.UserPresence = UserPresence;
UserPresence;
const WaterTemperatureValue = Unit.Temperature.Celsius.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.WaterTemperatureValue`,
    description: 'The water temperature read using NTC in degrees Celsius',
});
class WaterTemperature extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterTemperature`)({ value: WaterTemperatureValue }, { identifier: `${exports.NAMESPACE}.WaterTemperature` }) {
    static FromScalar = WaterTemperatureValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Temperature';
    static description = 'Water temperature read using NTC';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Temperature'];
    static unit = 'Celsius';
}
exports.WaterTemperature = WaterTemperature;
WaterTemperature;
const WaterTemperatureDecicelsiusValue = Unit.Temperature.Decicelsius.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.WaterTemperatureDecicelsiusValue`,
    description: 'The water temperature read using NTC in degrees Decicelsius',
});
class WaterTemperatureDecicelsius extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterTemperatureDecicelsius`)({ value: WaterTemperatureDecicelsiusValue }, { identifier: `${exports.NAMESPACE}.WaterTemperatureDecicelsius` }) {
    static FromScalar = WaterTemperatureDecicelsiusValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Temperature';
    static description = 'Water temperature read using NTC';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Temperature'];
    static unit = 'Decicelsius';
}
exports.WaterTemperatureDecicelsius = WaterTemperatureDecicelsius;
WaterTemperatureDecicelsius;
const WaterDispensedValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.WaterDispensedValue`,
    description: 'Overall water dispensed obtained by a flowmeter',
});
class WaterDispensed extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterDispensed`)({ value: WaterDispensedValue }, { identifier: `${exports.NAMESPACE}.WaterDispensed` }) {
    static FromScalar = WaterDispensedValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Dispensed';
    static description = 'Overall water dispensed obtained by a flowmeter';
    static type = 'native';
    static sendingStyle = 'onchange';
    static unit = 'Liter';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['DispensedVolume'];
}
exports.WaterDispensed = WaterDispensed;
WaterDispensed;
const DoorOpenValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.DoorOpenValue`,
    description: 'A Boolean indicating whether the door of the product is open',
});
class DoorOpen extends effect_1.Schema.Class(`${exports.NAMESPACE}.DoorOpen`)({ value: DoorOpenValue }, { identifier: `${exports.NAMESPACE}.DoorOpen` }) {
    static FromScalar = DoorOpenValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Door Open';
    static description = 'When the door of the product is open';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['User'];
    static unit = null;
}
exports.DoorOpen = DoorOpen;
DoorOpen;
const LeakDetectedValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.LeakDetectedValue`,
    description: 'A boolean indicating whether the sensor is detecting a leak',
});
class LeakDetected extends effect_1.Schema.Class(`${exports.NAMESPACE}.LeakDetected`)({ value: LeakDetectedValue }, { identifier: `${exports.NAMESPACE}.LeakDetected` }) {
    static FromScalar = LeakDetectedValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Ground Leak Detected';
    static description = 'The sensor is detecting a leak';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Sensors'];
    static unit = null;
}
exports.LeakDetected = LeakDetected;
LeakDetected;
const DripTrayFullValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.DripTrayFullValue`,
    description: 'A boolean indicating whether the drip tray is full',
});
class DripTrayFull extends effect_1.Schema.Class(`${exports.NAMESPACE}.DripTrayFull`)({ value: DripTrayFullValue }, { identifier: `${exports.NAMESPACE}.DripTrayFull` }) {
    static FromScalar = DripTrayFullValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Drip Tray Full';
    static description = 'When the drip tray is full';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = ['admin'];
    static tags = ['Sensors'];
    static unit = null;
}
exports.DripTrayFull = DripTrayFull;
DripTrayFull;
const WaterTDSValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.WaterTDSValue`,
    description: 'Water TDS in PPM',
});
class WaterTDS extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterTDS`)({ value: WaterTDSValue }, { identifier: `${exports.NAMESPACE}.WaterTDS` }) {
    static FromScalar = WaterTDSValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water TDS';
    static description = 'Water TDS in PPM';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Filtration'];
    static unit = 'PartsPerMillion';
}
exports.WaterTDS = WaterTDS;
WaterTDS;
const TdsReductionValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.TdsReductionValue`,
    description: 'Percentual TDS reduction between pre-treatment and post-treatment water',
});
class TdsReduction extends effect_1.Schema.Class(`${exports.NAMESPACE}.TdsReduction`)({ value: TdsReductionValue }, { identifier: `${exports.NAMESPACE}.TdsReduction` }) {
    static FromScalar = TdsReductionValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'TDS Reduction';
    static description = 'Percentual TDS reduction between pre-treatment and post-treatment water';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Filtration'];
    static unit = 'Integer';
}
exports.TdsReduction = TdsReduction;
TdsReduction;
const TotalInteractionsValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.TotalInteractionsValue`,
    description: 'Total number of times the sensor recorded an interaction',
});
class TotalInteractions extends effect_1.Schema.Class(`${exports.NAMESPACE}.TotalInteractions`)({ value: TotalInteractionsValue }, { identifier: `${exports.NAMESPACE}.TotalInteractions` }) {
    static FromScalar = TotalInteractionsValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Total Pourings';
    static description = 'Total number of times the sensor recorded an interaction';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Interactions'];
    static unit = 'Integer';
}
exports.TotalInteractions = TotalInteractions;
TotalInteractions;
const TotalCompressorCyclesValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.TotalCompressorCyclesValue`,
    description: 'The total number of compressor cycles',
});
class TotalCompressorCycles extends effect_1.Schema.Class(`${exports.NAMESPACE}.TotalCompressorCycles`)({ value: TotalCompressorCyclesValue }, { identifier: `${exports.NAMESPACE}.TotalCompressorCycles` }) {
    static FromScalar = TotalCompressorCyclesValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Total Compressor Cycles';
    static description = 'The total number of compressor cycles';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Temperature'];
    static unit = 'Integer';
}
exports.TotalCompressorCycles = TotalCompressorCycles;
TotalCompressorCycles;
const TotalHotTankCyclesValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.TotalHotTankCyclesValue`,
    description: 'The total number of hot tank cycles',
});
class TotalHotTankCycles extends effect_1.Schema.Class(`${exports.NAMESPACE}.TotalHotTankCycles`)({ value: TotalHotTankCyclesValue }, { identifier: `${exports.NAMESPACE}.TotalHotTankCycles` }) {
    static FromScalar = TotalHotTankCyclesValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Total Hot Tank Cycles';
    static description = 'The total number of hot tank cycles';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Temperature'];
    static unit = 'Integer';
}
exports.TotalHotTankCycles = TotalHotTankCycles;
TotalHotTankCycles;
const TotalTankTimeoutsValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.TotalTankTimeoutsValue`,
    description: 'Total number of times the tank timed out',
});
class TotalTankTimeouts extends effect_1.Schema.Class(`${exports.NAMESPACE}.TotalTankTimeouts`)({ value: TotalTankTimeoutsValue }, { identifier: `${exports.NAMESPACE}.TotalTankTimeouts` }) {
    static FromScalar = TotalTankTimeoutsValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Total Tank Timeouts';
    static description = 'Total number of times the tank timed out';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Temperature'];
    static unit = 'Integer';
}
exports.TotalTankTimeouts = TotalTankTimeouts;
TotalTankTimeouts;
const FlowRateValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.FlowRateValue`,
    description: 'Liquid flow rate in liters per minute',
});
class FlowRate extends effect_1.Schema.Class(`${exports.NAMESPACE}.FlowRate`)({ value: FlowRateValue }, { identifier: `${exports.NAMESPACE}.FlowRate` }) {
    static FromScalar = FlowRateValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flow Rate';
    static description = 'Liquid flow rate in liters per minute';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['FlowRate'];
    static unit = 'LitersPerMinute';
}
exports.FlowRate = FlowRate;
FlowRate;
const FlowRateDeciliterPerMinuteValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.FlowRateDeciliterPerMinuteValue`,
    description: 'Liquid flow rate in deciliters per minute',
});
class FlowRateDeciliterPerMinute extends effect_1.Schema.Class(`${exports.NAMESPACE}.FlowRateDeciliterPerMinute`)({ value: FlowRateDeciliterPerMinuteValue }, { identifier: `${exports.NAMESPACE}.FlowRateDeciliterPerMinute` }) {
    static FromScalar = FlowRateDeciliterPerMinuteValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flow Rate';
    static description = 'Liquid flow rate in deciliters per minute';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['FlowRate'];
    static unit = 'DecilitersPerMinute';
}
exports.FlowRateDeciliterPerMinute = FlowRateDeciliterPerMinute;
FlowRateDeciliterPerMinute;
const WaterPressureValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.WaterPressureValue`,
    description: 'Water pressure in Bar',
});
class WaterPressure extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterPressure`)({ value: WaterPressureValue }, { identifier: `${exports.NAMESPACE}.WaterPressure` }) {
    static FromScalar = WaterPressureValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Pressure';
    static description = 'Water pressure in Bar';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Pressure'];
    static unit = 'PoundsPerSquareInch';
}
exports.WaterPressure = WaterPressure;
WaterPressure;
const WaterPressureDecibarValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.WaterPressureDecibarValue`,
    description: 'Water pressure in Decibar',
});
class WaterPressureDecibar extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterPressureDecibar`)({ value: WaterPressureDecibarValue }, { identifier: `${exports.NAMESPACE}.WaterPressureDecibar` }) {
    static FromScalar = WaterPressureDecibarValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Pressure';
    static description = 'Water pressure in Decibar';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Pressure'];
    static unit = 'Decibar';
}
exports.WaterPressureDecibar = WaterPressureDecibar;
WaterPressureDecibar;
const ComponentEnabledValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.ComponentEnabledValue`,
    description: 'A boolean indicating whether the component is active or not',
});
class ComponentEnabled extends effect_1.Schema.Class(`${exports.NAMESPACE}.ComponentEnabled`)({ value: ComponentEnabledValue }, { identifier: `${exports.NAMESPACE}.ComponentEnabled` }) {
    static FromScalar = ComponentEnabledValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Component Enabled';
    static description = 'Whether the component is active or not';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = ['admin'];
    static tags = ['ComponentStatus'];
    static unit = null;
}
exports.ComponentEnabled = ComponentEnabled;
ComponentEnabled;
const ComponentOperationPermittedValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.ComponentOperationPermittedValue`,
    description: 'A boolean indicating whether the component is active or not',
});
class ComponentOperationPermitted extends effect_1.Schema.Class(`${exports.NAMESPACE}.ComponentOperationPermitted`)({ value: ComponentOperationPermittedValue }, { identifier: `${exports.NAMESPACE}.ComponentOperationPermitted` }) {
    static FromScalar = ComponentOperationPermittedValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Component Operation Permitted';
    static description = 'Whether the firmware allows the component to operate';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = ['admin'];
    static tags = ['ComponentStatus'];
    static unit = null;
}
exports.ComponentOperationPermitted = ComponentOperationPermitted;
ComponentOperationPermitted;
class FirewallEffectiveness extends effect_1.Schema.Class(`${exports.NAMESPACE}.FirewallEffectiveness`)({ value: effect_1.Schema.Number }, { identifier: `${exports.NAMESPACE}.FirewallEffectiveness` }) {
    static FromScalar = effect_1.Schema.Number.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Firewall Effectiveness';
    static description = 'The measured intensity of the firewall UVC light';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = ['admin'];
    static tags = ['Filtration'];
    static unit = null;
}
exports.FirewallEffectiveness = FirewallEffectiveness;
FirewallEffectiveness;
const EnergyUsageValue = Unit.Energy.KilowattHour.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.EnergyUsageValue`,
});
class EnergyUsage extends effect_1.Schema.Class(`${exports.NAMESPACE}.EnergyUsage`)({ value: EnergyUsageValue }, { identifier: `${exports.NAMESPACE}.EnergyUsage` }) {
    static FromScalar = EnergyUsageValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Energy usage';
    static description = 'Energy usage';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Energy'];
    static unit = 'KilowattHour';
}
exports.EnergyUsage = EnergyUsage;
EnergyUsage;
const DispenseCountValue = Unit.Count.Integer.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.DispenseCountValue`,
});
class DispenseCount extends effect_1.Schema.Class(`${exports.NAMESPACE}.DispenseCount`)({ value: DispenseCountValue }, { identifier: `${exports.NAMESPACE}.DispenseCount` }) {
    static FromScalar = DispenseCountValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Dispense count';
    static description = 'Dispense count';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Interactions'];
    static unit = 'Integer';
}
exports.DispenseCount = DispenseCount;
DispenseCount;
const DispenseVolumeValue = effect_1.Schema.Number.annotations({
    identifier: `${exports.NAMESPACE}.DispenseVolumeValue`,
});
class DispenseVolume extends effect_1.Schema.Class(`${exports.NAMESPACE}.DispenseVolume`)({ value: DispenseVolumeValue }, { identifier: `${exports.NAMESPACE}.DispenseVolume` }) {
    static FromScalar = DispenseVolumeValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Dispense volume';
    static description = 'Dispense volume';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Interactions'];
    static unit = 'Liter';
}
exports.DispenseVolume = DispenseVolume;
DispenseVolume;
const FloodSensorTriggeredValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.FloodSensorTriggeredValue`,
    description: 'A boolean indicating whether the flood sensor is triggered',
});
class FloodSensorTriggered extends effect_1.Schema.Class(`${exports.NAMESPACE}.FloodSensorTriggered`)({ value: FloodSensorTriggeredValue }, { identifier: `${exports.NAMESPACE}.FloodSensorTriggered` }) {
    static FromScalar = FloodSensorTriggeredValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flood Sensor Triggered';
    static description = 'When the flood sensor is triggered';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Sensors'];
    static unit = null;
}
exports.FloodSensorTriggered = FloodSensorTriggered;
FloodSensorTriggered;
const FloodSensorConnectedValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.FloodSensorConnectedValue`,
    description: 'A boolean indicating whether the flood sensor is connected',
});
class FloodSensorConnected extends effect_1.Schema.Class(`${exports.NAMESPACE}.FloodSensorConnected`)({ value: FloodSensorConnectedValue }, { identifier: `${exports.NAMESPACE}.FloodSensorConnected` }) {
    static FromScalar = FloodSensorConnectedValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flood Sensor Connected';
    static description = 'Whether the flood sensor is connected';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Sensors'];
    static unit = null;
}
exports.FloodSensorConnected = FloodSensorConnected;
FloodSensorConnected;
const SignalStrengthValue = effect_1.Schema.Int.pipe(effect_1.Schema.nonPositive()).annotations({
    identifier: `${exports.NAMESPACE}.SignalStrengthValue`,
    description: 'A non-positive integer representing a signal strength (RSSI) in dBm',
});
class SignalStrength extends effect_1.Schema.Class(`${exports.NAMESPACE}.SignalStrength`)({ value: SignalStrengthValue }, { identifier: `${exports.NAMESPACE}.SignalStrength` }) {
    static FromScalar = SignalStrengthValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Signal Strength';
    static description = 'RSSI of the connection';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Connectivity'];
    static unit = 'DecibelMilliwatts';
}
exports.SignalStrength = SignalStrength;
SignalStrength;
const WaterConductanceValue = effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()).annotations({
    identifier: `${exports.NAMESPACE}.WaterConductanceValue`,
    description: 'A non-negative integer representing the conductance of a body of water in ⅒μS/cm',
});
class WaterConductance extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterConductance`)({ value: WaterConductanceValue }, { identifier: `${exports.NAMESPACE}.WaterConductance` }) {
    static FromScalar = WaterConductanceValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Conductance';
    static description = 'Cond';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Filtration'];
    static unit = 'TenthMicrosiemensPerCentimeter';
}
exports.WaterConductance = WaterConductance;
WaterConductance;
const UptimeValue = effect_1.Schema.NonNegative.annotations({
    identifier: `${exports.NAMESPACE}.UptimeValue`,
});
class Uptime extends effect_1.Schema.Class(`${exports.NAMESPACE}.Uptime`)({ value: UptimeValue }, { identifier: `${exports.NAMESPACE}.Uptime` }) {
    static FromScalar = UptimeValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Uptime';
    static description = 'How long the system has been operating';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    static unit = 'Hour';
}
exports.Uptime = Uptime;
Uptime;
const SwitchValue = effect_1.Schema.Boolean.annotations({
    identifier: `${exports.NAMESPACE}.SwitchValue`,
    description: 'A boolean indicating whether the switch is open or closed',
});
class Switch extends effect_1.Schema.Class(`${exports.NAMESPACE}.Switch`)({ value: SwitchValue }, { identifier: `${exports.NAMESPACE}.Switch` }) {
    static FromScalar = SwitchValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Switch';
    static description = 'Whether the switch is open or closed';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Sensors'];
    static unit = null;
}
exports.Switch = Switch;
Switch;
const RefrigerationCycleTimeValue = effect_1.Schema.Number.pipe(effect_1.Schema.nonNegative()).annotations({
    identifier: `${exports.NAMESPACE}.RefrigerationCycleTimeValue`,
    description: 'Refrigeration cycle time in minutes to 1 decimal point',
});
class RefrigerationCycleTime extends effect_1.Schema.Class(`${exports.NAMESPACE}.RefrigerationCycleTime`)({ value: RefrigerationCycleTimeValue }, { identifier: `${exports.NAMESPACE}.RefrigerationCycleTime` }) {
    static FromScalar = RefrigerationCycleTimeValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Refrigeration Cycle Time';
    static description = 'Refrigeration cycle time in minutes to 1 decimal point';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    static unit = 'Minute';
}
exports.RefrigerationCycleTime = RefrigerationCycleTime;
RefrigerationCycleTime;
const WaterUsagePercentageValue = effect_1.Schema.Number.pipe(effect_1.Schema.between(0, 100)).annotations({
    identifier: `${exports.NAMESPACE}.WaterUsagePercentageValue`,
    description: 'Water usage percentage since last filter replacement (0-100)',
});
class WaterUsagePercentage extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterUsagePercentage`)({ value: WaterUsagePercentageValue }, { identifier: `${exports.NAMESPACE}.WaterUsagePercentage` }) {
    static FromScalar = WaterUsagePercentageValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Usage Percentage';
    static description = 'Percentage of water used since last filter replacement';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['DispensedVolume'];
    static unit = 'Percentage';
}
exports.WaterUsagePercentage = WaterUsagePercentage;
WaterUsagePercentage;
const CO2RegulatorGaugePressureValue = effect_1.Schema.Number.pipe(effect_1.Schema.between(-101, 1000)).annotations({
    identifier: `${exports.NAMESPACE}.CO2RegulatorGaugePressureValue`,
    description: 'CO2 regulator gauge pressure in kPa, atmospheric pressure (101.3 kPa) subtracted',
});
class CO2RegulatorGaugePressure extends effect_1.Schema.Class(`${exports.NAMESPACE}.CO2RegulatorGaugePressure`)({ value: CO2RegulatorGaugePressureValue }, { identifier: `${exports.NAMESPACE}.CO2RegulatorGaugePressure` }) {
    static FromScalar = CO2RegulatorGaugePressureValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'CO2 Regulator Gauge Pressure';
    static description = 'CO2 gas canister regulator gauge pressure in kPa, as measured by the CO2 sensor';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Pressure'];
    static unit = 'KilopascalGauge';
}
exports.CO2RegulatorGaugePressure = CO2RegulatorGaugePressure;
CO2RegulatorGaugePressure;
const CO2SensorAdcValue = effect_1.Schema.Int.pipe(effect_1.Schema.between(-100, 1024)).annotations({
    identifier: `${exports.NAMESPACE}.CO2SensorAdcValue`,
    description: 'Raw ADC reading of the CO2 mems sensor, nominally close to 203 with no gas flow',
});
class CO2SensorAdc extends effect_1.Schema.Class(`${exports.NAMESPACE}.CO2SensorAdc`)({ value: CO2SensorAdcValue }, { identifier: `${exports.NAMESPACE}.CO2SensorAdc` }) {
    static FromScalar = CO2SensorAdcValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'CO2 Sensor ADC';
    static description = 'Raw ADC reading of the CO2 mems sensor';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Sensors'];
    static unit = null;
}
exports.CO2SensorAdc = CO2SensorAdc;
CO2SensorAdc;
const WaterTemperatureFahrenheitValue = Unit.Temperature.Fahrenheit.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.WaterTemperatureFahrenheitValue`,
    description: 'The water temperature in degrees Fahrenheit',
});
class WaterTemperatureFahrenheit extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterTemperatureFahrenheit`)({ value: WaterTemperatureFahrenheitValue }, { identifier: `${exports.NAMESPACE}.WaterTemperatureFahrenheit` }) {
    static FromScalar = WaterTemperatureFahrenheitValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Temperature';
    static description = 'Water temperature in degrees Fahrenheit';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Temperature'];
    static unit = 'Fahrenheit';
}
exports.WaterTemperatureFahrenheit = WaterTemperatureFahrenheit;
WaterTemperatureFahrenheit;
const FlowRateMilliliterPerMinuteValue = Unit.FlowRate.MillilitersPerMinute.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.FlowRateMilliliterPerMinuteValue`,
    description: 'Liquid flow rate in milliliters per minute',
});
class FlowRateMilliliterPerMinute extends effect_1.Schema.Class(`${exports.NAMESPACE}.FlowRateMilliliterPerMinute`)({ value: FlowRateMilliliterPerMinuteValue }, { identifier: `${exports.NAMESPACE}.FlowRateMilliliterPerMinute` }) {
    static FromScalar = FlowRateMilliliterPerMinuteValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flow Rate';
    static description = 'Liquid flow rate in milliliters per minute';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['FlowRate'];
    static unit = 'MillilitersPerMinute';
}
exports.FlowRateMilliliterPerMinute = FlowRateMilliliterPerMinute;
FlowRateMilliliterPerMinute;
const FlowRateUsGallonsPerMinuteValue = Unit.FlowRate.UsGallonsPerMinute.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.FlowRateUsGallonsPerMinuteValue`,
    description: 'Liquid flow rate in US gallons per minute',
});
class FlowRateUsGallonsPerMinute extends effect_1.Schema.Class(`${exports.NAMESPACE}.FlowRateUsGallonsPerMinute`)({ value: FlowRateUsGallonsPerMinuteValue }, { identifier: `${exports.NAMESPACE}.FlowRateUsGallonsPerMinute` }) {
    static FromScalar = FlowRateUsGallonsPerMinuteValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Flow Rate';
    static description = 'Liquid flow rate in US gallons per minute';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['FlowRate'];
    static unit = 'UsGallonsPerMinute';
}
exports.FlowRateUsGallonsPerMinute = FlowRateUsGallonsPerMinute;
FlowRateUsGallonsPerMinute;
const WaterVolumeUsGallonsValue = Unit.Volume.UsGallon.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.WaterVolumeUsGallonsValue`,
    description: 'Overall water volume measured by a flowmeter in US gallons',
});
class WaterVolumeUsGallons extends effect_1.Schema.Class(`${exports.NAMESPACE}.WaterVolumeUsGallons`)({ value: WaterVolumeUsGallonsValue }, { identifier: `${exports.NAMESPACE}.WaterVolumeUsGallons` }) {
    static FromScalar = WaterVolumeUsGallonsValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Water Volume';
    static description = 'Overall water volume measured by a flowmeter in US gallons';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['DispensedVolume'];
    static unit = 'UsGallon';
}
exports.WaterVolumeUsGallons = WaterVolumeUsGallons;
WaterVolumeUsGallons;
const DispenseVolumeUsFluidOuncesValue = Unit.Volume.UsFluidOunce.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.DispenseVolumeUsFluidOuncesValue`,
    description: 'Dispense volume in US fluid ounces',
});
class DispenseVolumeUsFluidOunces extends effect_1.Schema.Class(`${exports.NAMESPACE}.DispenseVolumeUsFluidOunces`)({ value: DispenseVolumeUsFluidOuncesValue }, { identifier: `${exports.NAMESPACE}.DispenseVolumeUsFluidOunces` }) {
    static FromScalar = DispenseVolumeUsFluidOuncesValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Dispense volume';
    static description = 'Dispense volume in US fluid ounces';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Interactions'];
    static unit = 'UsFluidOunce';
}
exports.DispenseVolumeUsFluidOunces = DispenseVolumeUsFluidOunces;
DispenseVolumeUsFluidOunces;
const SystemEfficiencyValue = effect_1.Schema.Number.pipe(effect_1.Schema.between(0, 100)).annotations({
    identifier: `${exports.NAMESPACE}.SystemEfficiencyValue`,
    description: 'Permeate produced as a percentage of the feed water consumed (0-100)',
});
class SystemEfficiency extends effect_1.Schema.Class(`${exports.NAMESPACE}.SystemEfficiency`)({ value: SystemEfficiencyValue }, { identifier: `${exports.NAMESPACE}.SystemEfficiency` }) {
    static FromScalar = SystemEfficiencyValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'System Efficiency';
    static description = 'Permeate produced as a percentage of the feed water consumed';
    static type = 'native';
    static sendingStyle = 'always';
    static roles = ['admin'];
    static tags = ['Filtration'];
    static unit = 'Percentage';
}
exports.SystemEfficiency = SystemEfficiency;
SystemEfficiency;
const TankLevelPercentageValue = effect_1.Schema.Number.pipe(effect_1.Schema.between(0, 100)).annotations({
    identifier: `${exports.NAMESPACE}.TankLevelPercentageValue`,
    description: 'Tank fill level as a percentage (0-100)',
});
class TankLevelPercentage extends effect_1.Schema.Class(`${exports.NAMESPACE}.TankLevelPercentage`)({ value: TankLevelPercentageValue }, { identifier: `${exports.NAMESPACE}.TankLevelPercentage` }) {
    static FromScalar = TankLevelPercentageValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Tank Level';
    static description = 'Tank fill level as a percentage';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
        'user',
    ];
    static tags = ['Sensors'];
    static unit = 'Percentage';
}
exports.TankLevelPercentage = TankLevelPercentage;
TankLevelPercentage;
const CycleDurationValue = Unit.Time.Second.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.CycleDurationValue`,
    description: 'Duration of an operating cycle in seconds',
});
class CycleDuration extends effect_1.Schema.Class(`${exports.NAMESPACE}.CycleDuration`)({ value: CycleDurationValue }, { identifier: `${exports.NAMESPACE}.CycleDuration` }) {
    static FromScalar = CycleDurationValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Cycle Duration';
    static description = 'Duration of an operating cycle in seconds';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    static unit = 'Second';
}
exports.CycleDuration = CycleDuration;
CycleDuration;
const CycleCountValue = Unit.Count.Integer.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.CycleCountValue`,
    description: 'Number of operating cycles completed',
});
class CycleCount extends effect_1.Schema.Class(`${exports.NAMESPACE}.CycleCount`)({ value: CycleCountValue }, { identifier: `${exports.NAMESPACE}.CycleCount` }) {
    static FromScalar = CycleCountValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Cycle Count';
    static description = 'Number of operating cycles completed';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    static unit = 'Integer';
}
exports.CycleCount = CycleCount;
CycleCount;
const DayCounterValue = Unit.Count.Integer.fields.amount.annotations({
    identifier: `${exports.NAMESPACE}.DayCounterValue`,
    description: 'A count of days',
});
class DayCounter extends effect_1.Schema.Class(`${exports.NAMESPACE}.DayCounter`)({ value: DayCounterValue }, { identifier: `${exports.NAMESPACE}.DayCounter` }) {
    static FromScalar = DayCounterValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Day Counter';
    static description = 'A count of days';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    static unit = 'Day';
}
exports.DayCounter = DayCounter;
DayCounter;
const CellularBitErrorRateValue = effect_1.Schema.Union(effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 7)), effect_1.Schema.Literal(99)).annotations({
    identifier: `${exports.NAMESPACE}.CellularBitErrorRateValue`,
    description: 'Cellular channel bit error rate as reported by the modem (0-7, 99 when unknown)',
});
class CellularBitErrorRate extends effect_1.Schema.Class(`${exports.NAMESPACE}.CellularBitErrorRate`)({ value: CellularBitErrorRateValue }, { identifier: `${exports.NAMESPACE}.CellularBitErrorRate` }) {
    static FromScalar = CellularBitErrorRateValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Cellular Bit Error Rate';
    static description = 'Cellular channel bit error rate as reported by the modem';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Connectivity'];
    static unit = 'Integer';
}
exports.CellularBitErrorRate = CellularBitErrorRate;
CellularBitErrorRate;
const ReportedSignalStrengthValue = effect_1.Schema.Union(effect_1.Schema.Int.pipe(effect_1.Schema.nonPositive()), effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 31)), effect_1.Schema.Literal(99)).annotations({
    identifier: `${exports.NAMESPACE}.ReportedSignalStrengthValue`,
    description: 'Signal strength as reported by the modem: an RSSI in dBm, a 0-31 CSQ index, or 99 when unknown',
});
// Accepts every scale the modem may use, so an unexpected reading cannot reject the whole message.
// Replace it with SignalStrength once the scale is confirmed.
class ReportedSignalStrength extends effect_1.Schema.Class(`${exports.NAMESPACE}.ReportedSignalStrength`)({ value: ReportedSignalStrengthValue }, { identifier: `${exports.NAMESPACE}.ReportedSignalStrength` }) {
    static FromScalar = ReportedSignalStrengthValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Signal Strength';
    static description = 'Signal strength as reported by the modem, in a scale that is not confirmed yet';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['Connectivity'];
    static unit = 'Integer';
}
exports.ReportedSignalStrength = ReportedSignalStrength;
ReportedSignalStrength;
const EventTimeValue = effect_1.Schema.NonNegative.pipe(effect_1.Schema.int()).annotations({
    identifier: `${exports.NAMESPACE}.EventTimeValue`,
    description: 'Time of an event as a Unix epoch timestamp in milliseconds',
});
class EventTime extends effect_1.Schema.Class(`${exports.NAMESPACE}.EventTime`)({ value: EventTimeValue }, { identifier: `${exports.NAMESPACE}.EventTime` }) {
    static FromScalar = EventTimeValue.pipe(Value).pipe(effect_1.Schema.compose(this));
    static label = 'Event Time';
    static description = 'Time of an event as a Unix epoch timestamp in milliseconds';
    static type = 'native';
    static sendingStyle = 'onchange';
    static roles = [
        'admin',
        'brandManager',
        'brandSupportOperator',
        'brandTechOperator',
        'sysAdmin',
    ];
    static tags = ['System'];
    // A point in time, not a duration: no unit, so it is never converted like one
    static unit = null;
}
exports.EventTime = EventTime;
EventTime;
exports.booleanTelemetries = {
    ComponentEnabled,
    ComponentOperationPermitted,
    UserPresence,
    DoorOpen,
    LeakDetected,
    DripTrayFull,
    FloodSensorTriggered,
    FloodSensorConnected,
    Switch,
};
exports.numberTelemetries = {
    WaterTemperature,
    WaterTemperatureDecicelsius,
    WaterDispensed,
    WaterTDS,
    TdsReduction,
    TotalInteractions,
    TotalCompressorCycles,
    TotalHotTankCycles,
    TotalTankTimeouts,
    FlowRate,
    FlowRateDeciliterPerMinute,
    WaterPressure,
    WaterPressureDecibar,
    FirewallEffectiveness,
    EnergyUsage,
    DispenseCount,
    DispenseVolume,
    SignalStrength,
    WaterConductance,
    Uptime,
    RefrigerationCycleTime,
    WaterUsagePercentage,
    CO2RegulatorGaugePressure,
    CO2SensorAdc,
    WaterTemperatureFahrenheit,
    FlowRateMilliliterPerMinute,
    FlowRateUsGallonsPerMinute,
    WaterVolumeUsGallons,
    DispenseVolumeUsFluidOunces,
    SystemEfficiency,
    TankLevelPercentage,
    CycleDuration,
    CycleCount,
    DayCounter,
    CellularBitErrorRate,
    ReportedSignalStrength,
    EventTime,
};
exports.telemetries = {
    ...exports.booleanTelemetries,
    ...exports.numberTelemetries,
};
exports.BooleanTelemetry = effect_1.Schema.Union(...effect_1.Record.values(exports.booleanTelemetries)).annotations({
    identifier: `${exports.NAMESPACE}.BooleanTelemetry`,
});
exports.NumberTelemetry = effect_1.Schema.Union(...effect_1.Record.values(exports.numberTelemetries)).annotations({
    identifier: `${exports.NAMESPACE}.NumberTelemetry`,
});
exports.Telemetry = effect_1.Schema.Union(...effect_1.Record.values(exports.telemetries)).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
//# sourceMappingURL=telemetry.js.map